import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setModal } from "../../store/reducers/helpersReducer";
import { addToMountedCache, fetchMounted, fetchState, updateMounted } from "../../store/reducers/stateReducer";
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, {
    accordionSummaryClasses,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Button, Alert, Snackbar, Box, Tabs, Tab, useTheme, IconButton, Fade, Slide } from "@mui/material";
import { useAuth } from "react-oidc-context";
import DialogActions from '@mui/material/DialogActions';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import ClearIcon from '@mui/icons-material/Clear';
import RestoreIcon from '@mui/icons-material/Restore';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EventIcon from '@mui/icons-material/Event';
import Tooltip from '@mui/material/Tooltip';
import { useMap } from "react-leaflet";
import { aimToObject } from "../controls/helpers";
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { createPortal } from "react-dom";
import ObjectsTable from './ModalExecution/ObjectsTable';
import ObjectsFidersTable from './ModalExecution/ObjectsFidersTableNew';
import { selectPillarsWithAccountingsFiltered } from "../../store/selectors/supervisionSelector";
import L from "leaflet";
import { $authHost } from "../../http";
import { progress } from "framer-motion";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
        transform: 'rotate(90deg)',
    },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
        padding: '0px'
    },
    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255, 255, 255, .05)',
    }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));


const materialMapping = {
    '1': 'Дерево',
    '2': 'Железобетон',
    '3': 'Сталь'
}

const StyledTableCellAccounting = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#CD5C5C',
        color: 'white',
        padding: '5px',
        fontSize: '14px',
        fontWeight: 'bold'
    },
    [`&.${tableCellClasses.body}`]: {
        padding: '5px',
        fontSize: 14,
        lineHeight: 1
    },
}));

const StyledTableCellSpec = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#D0D0D0',
        color: 'black',
        padding: '4px 4px',
        fontSize: '16px',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#909090',
            cursor: 'pointer'
        },
        '@media (max-width: 768px)': {
            fontSize: '12px',
            padding: '1px 2px',
        }
    },
    [`&.${tableCellClasses.body}`]: {
        padding: '2px 4px',
        fontSize: 14,
        '@media (max-width: 768px)': {
            fontSize: '12px',
            padding: '1px 2px',
        }
    },
}));

const StyledTableCellSpecCompact = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#D0D0D0',
        color: 'black',
        padding: '2px 2px',
        fontSize: '14px',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#909090',
            cursor: 'pointer'
        }
    },
    [`&.${tableCellClasses.body}`]: {
        padding: '1px 2px',
        fontSize: 12,
    },
}));

const StyledTableCellSpecCat = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        padding: '2px 4px',
        fontSize: 14,
        fontWeight: 'bold',
        '@media (max-width: 768px)': {
            fontSize: '12px',
            padding: '1px 2px',
        }
    },
}));

const StyledTableRowSpec = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'allChecked'
})(({ theme, allChecked }) => ({
    backgroundColor: allChecked ? '#e8f5e9' : '#fff3e0',
}));

const StyledTableRowSpec2 = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'allChecked' && prop !== 'disabled'
})(({ theme, status, disabled }) => ({
    backgroundColor: disabled
        ? '#f5f5f5'
        : status === 1
            ? '#e8f5e9'
            : status === 2
                ? '#FFFEE1'
                : '#FFE1D7',
    opacity: disabled ? 0.6 : 1,
    '& > td:not(:first-of-type)': {
        pointerEvents: disabled ? 'none' : 'auto',
    },
    '& > td:not(:first-of-type) *': {
        color: disabled ? '#999 !important' : 'inherit'
    }
}));

const StyledTableRowSpecDisabled = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'allChecked' && prop !== 'disabled'
})(({ theme, allChecked, disabled }) => ({
    backgroundColor: disabled
        ? '#f5f5f5'
        : allChecked
            ? '#e8f5e9'
            : '#fff3e0',
    opacity: disabled ? 0.6 : 1,
    '& > td:not(:first-of-type)': {
        pointerEvents: disabled ? 'none' : 'auto',
    },
    '& > td:not(:first-of-type) *': {
        color: disabled ? '#999 !important' : 'inherit'
    }
}));

const ModalExecution = (props) => {
    const map = useMap()
    const dispatch = useDispatch()
    const auth = useAuth()
    const theme = useTheme()
    const darkMode = useSelector(state => state.state.darkMode)
    const [objects, setObjects] = useState({
        pillars: [],
        zvz: [],
        opn: [],
        rlnd: [],
        transformers: [],
        runn: []
    })
    const [objectsFiders, setObjectsFiders] = useState([])
    // const [types, setTypes] = useState([])

    // Refs для дочерних компонентов
    const objectsTableRef = useRef(null);
    const objectsFidersTableRef = useRef(null);
    const executionDateTimeInputRef = useRef(null);
    const { transformers, pillarsZvz, pillarsOpn, fiders, pillarsRlnd, pillarsRunn } = useSelector(
        (state) => ({
            transformers: state.state.electricityFiltered.transformers,
            pillarsZvz: state.state.electricityFiltered.pillarsZvz,
            pillarsOpn: state.state.electricityFiltered.pillarsOpn,
            fiders: state.state.electricityFiltered.fiders,
            pillarsRlnd: state.state.electricityFiltered.pillarsRlnd,
            pillarsRunn: state.state.electricityFiltered.pillarsRunn
        }),
        (l, r) => JSON.stringify(l.transformers) === JSON.stringify(r.transformers) && JSON.stringify(l.pillarsZvz) === JSON.stringify(r.pillarsZvz) && JSON.stringify(l.pillarsOpn) === JSON.stringify(r.pillarsOpn) && JSON.stringify(l.fiders) === JSON.stringify(r.fiders) && JSON.stringify(l.pillarsRlnd) === JSON.stringify(r.pillarsRlnd) && JSON.stringify(l.pillarsRunn) === JSON.stringify(r.pillarsRunn)
    );
    const pillars = useSelector(state => state.state.electricity.pillars)
    const user = useSelector(state => state.state.user, (l, r) => l.id === r.id)


    // const mounted = useMemo(() => {
    //     return props.mounted || null
    // }, [props.mounted])
    const { mounted, specs } = useSelector(
        (state) => ({
            mounted: state.state.mounted,
            specs: state.state.specs
        }),
        (l, r) => JSON.stringify(l.mounted) === JSON.stringify(r.mounted) && JSON.stringify(l.specs) === JSON.stringify(r.specs)
    );



    const { pillarsIds, zvzIds, opnIds, rlndIds, fiderIds, transformersIds, runnIds } = useMemo(() => {
        return props.ids
    }, [props.ids])
    const mode = useMemo(() => {
        return props.mode
    }, [props.mode])
    const [searchText, setSearchText] = useState('')
    const [debouncedSearchText, setDebouncedSearchText] = useState('')
    const [searchInComplect, setSearchInComplect] = useState(false)
    const [smallMode, setSmallMode] = useState(false)
    const [activeTab, setActiveTab] = useState(0);

    // Состояния для позиции и размеров окна в smallMode
    const [windowPosition, setWindowPosition] = useState({ x: 20, y: 20 });
    const [windowSize, setWindowSize] = useState({ width: 400, height: 600 });
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [resizeStart, setResizeStart] = useState({ x: 0, y: 0, width: 0, height: 0 });

    // Функции для работы с localStorage
    const saveWindowSettings = useCallback((position, size) => {
        try {
            localStorage.setItem('modalExecution_windowPosition', JSON.stringify(position));
            localStorage.setItem('modalExecution_windowSize', JSON.stringify(size));
        } catch (error) {
            console.warn('Не удалось сохранить настройки окна:', error);
        }
    }, []);

    const loadWindowSettings = useCallback(() => {
        try {
            const savedPosition = localStorage.getItem('modalExecution_windowPosition');
            const savedSize = localStorage.getItem('modalExecution_windowSize');

            if (savedPosition) {
                const position = JSON.parse(savedPosition);
                setWindowPosition(position);
            }

            if (savedSize) {
                const size = JSON.parse(savedSize);
                setWindowSize(size);
            }
        } catch (error) {
            console.warn('Не удалось загрузить настройки окна:', error);
        }
    }, []);

    const [selectedItems, setSelectedItems] = useState({});
    const [disabledItems, setDisabledItems] = useState({})
    const [defaultSelectedItems, setDefaultSelectedItems] = useState({});
    const [defaultDisabledItems, setDefaultDisabledItems] = useState({})
    const [itemMetadata, setItemMetadata] = useState({}); // Метаданные элементов (date, userid)

    const [error, setError] = useState(false)
    const [selectedItemsLengths, setSelectedItemsLengths] = useState({});

    const [disabledObjects, setDisabledObjects] = useState({});
    const [resetKey, setResetKey] = useState(0);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [expandedItems, setExpandedItems] = useState([]);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorAlertMessage, setErrorAlertMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const addButtonRef = useRef(null);
    const dialogRef = useRef(null);

    // Состояние для даты и времени выполнения (по умолчанию текущая дата и время)
    const getCurrentDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    const [executionDateTime, setExecutionDateTime] = useState(getCurrentDateTime());



    const handleClose = () => {
        dispatch(setModal(null))
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    // Функция очистки поиска
    const handleClearSearch = () => {
        setSearchText('');
        setDebouncedSearchText('');
    };


    useEffect(() => {
        console.log(selectedItems)
        console.log(disabledItems)
    }, [selectedItems, disabledItems]);




    // Debounce для поиска
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchText(searchText);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchText]);

    // Загрузка настроек окна при монтировании
    useEffect(() => {
        loadWindowSettings();
    }, [loadWindowSettings]);

    // Обработчик клавиши Escape
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape' && !smallMode) {
                handleClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [smallMode, handleClose]);

    // Обработчики для перетаскивания и изменения размеров
    const handleDragHandleMouseDown = useCallback((e) => {
        if (!smallMode) return;

        e.preventDefault();
        e.stopPropagation();

        setIsDragging(true);
        setDragStart({
            x: e.clientX - windowPosition.x,
            y: e.clientY - windowPosition.y
        });
    }, [smallMode, windowPosition]);

    const handleResizeHandleMouseDown = useCallback((e) => {
        if (!smallMode) return;

        e.preventDefault();
        e.stopPropagation();

        setIsResizing(true);
        setResizeStart({
            x: e.clientX,
            y: e.clientY,
            width: windowSize.width,
            height: windowSize.height
        });
    }, [smallMode, windowSize]);

    const handleMouseMove = useCallback((e) => {
        if (!smallMode) return;

        if (isDragging) {
            const newX = e.clientX - dragStart.x;
            const newY = e.clientY - dragStart.y;

            // Ограничиваем позицию в пределах экрана
            const maxX = window.innerWidth - windowSize.width;
            const maxY = window.innerHeight - windowSize.height;

            setWindowPosition({
                x: Math.max(0, Math.min(newX, maxX)),
                y: Math.max(0, Math.min(newY, maxY))
            });
        } else if (isResizing) {
            const deltaX = e.clientX - resizeStart.x;
            const deltaY = e.clientY - resizeStart.y;

            const newWidth = Math.max(300, resizeStart.width + deltaX);
            const newHeight = Math.max(200, resizeStart.height + deltaY);

            setWindowSize({
                width: newWidth,
                height: newHeight
            });
        }
    }, [smallMode, isDragging, isResizing, dragStart, resizeStart, windowSize]);

    const handleMouseUp = useCallback(() => {
        if (isDragging || isResizing) {
            setIsDragging(false);
            setIsResizing(false);
            saveWindowSettings(windowPosition, windowSize);
        }
    }, [isDragging, isResizing, windowPosition, windowSize, saveWindowSettings]);

    // Добавляем глобальные обработчики событий мыши
    useEffect(() => {
        if (smallMode && (isDragging || isResizing)) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);

            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [smallMode, isDragging, isResizing, handleMouseMove, handleMouseUp]);


    function selectObjectFider(f) {
        // const pillar1 = fider.object_1_type === 'pillar' ? objects.pillars.find(p => p.fid === fider.pillar1) : 
        // const pillar2 = objects.pillars.find(p => p.fid === fider.pillar2)

        const object1 = f.object_1_type === 'pillar' ? objects.pillars.find(p => p.fid === f.object_1_fid) : transformers.find(p => p.fid === f.object_1_fid);
        const object2 = f.object_2_type === 'pillar' ? objects.pillars.find(p => p.fid === f.object_2_fid) : transformers.find(p => p.fid === f.object_2_fid);

        if (object1 && object2) {
            // selectObject(pillar1, 'pillars')
            // selectObject(pillar2, 'pillars')
            selectObject(object1)
            selectObject(object2)
        }
    }

    function selectObject(object) {
        setSmallMode(true)
        aimToObject(map, object)




    }

    function evalMaxQuantity(object1, object2) {
        // let maxQuantity = 1;
        let typesFiders = specs.fiders.filter(s => s.name.includes('СИП-'));
        if (object1?.tags?.class === 'pillar04' || object2?.tags?.class === 'pillar04') {
            typesFiders = specs.fiders.filter(s => s.name.includes('СИП-2') || s.name.includes('СИП-4'));
        } else if (object1?.tags?.class === 'pillar10' || object2?.tags?.class === 'pillar10') {
            typesFiders = specs.fiders.filter(s => s.name.includes('СИП-3'));
        } else if (object1?.tags?.class === 'pillar04-10' && object2?.tags?.class === 'pillar04-10') {
            typesFiders = specs.fiders.filter(s => s.name.includes('СИП-'));
        }

        const chains1 = object1?.type?.includes('pillar') ? object1.mounted.chains : Infinity
        const chains2 = object2?.type?.includes('pillar') ? object2.mounted.chains : Infinity
        const maxQuantity = Math.min(chains1, chains2)


        return { maxQuantity, typesFiders };
    }

    useEffect(() => {
        if (addButtonRef.current) {
            setError(true)
        } else {
            setError(false)
        }
    }, [addButtonRef, objectsFiders])

    // Check for errors in fiders configuration
    // useEffect(() => {
    //     if (!specs.fiders || !objectsFiders.length || !mode) {
    //         setError(false);
    //         return;
    //     }

    //     let hasErrors = false;

    //     Object.entries(objects).forEach(([key, value]) => {
    //         value.forEach(p => {
    //             if (p.spec.id !== p.mounted.id && (!p.mounted.justify || p.mounted.justify === '')) {
    //                 hasErrors = true;
    //             }
    //         })
    //     })

    //     objectsFiders.forEach(f => {
    //         // const object1 = f.object_1_type === 'pillar' ? objects.pillars.find(p => p.fid === f.object_1_fid) : transformers.find(p => p.fid === f.object_1_fid);
    //         // const object2 = f.object_2_type === 'pillar' ? objects.pillars.find(p => p.fid === f.object_2_fid) : transformers.find(p => p.fid === f.object_2_fid);
    //         const object1 = f.object1
    //         const object2 = f.object2
    //         if (!object1 || !object2) return;


    //         const { maxQuantity, typesFiders } = evalMaxQuantity(object1, object2);

    //         // Check if any mounted item has invalid id
    //         const hasInvalidIds = f.mounted.some(m => !typesFiders.find(tf => tf.id === m.id)) || f.mounted.some(m => m.quantity > maxQuantity);
    //         const isQuantityInsufficient = f.mountedQuantity > f.mounted.reduce((sum, m) => sum + m.quantity, 0) || f.mountedQuantity > maxQuantity;

    //         if (hasInvalidIds || isQuantityInsufficient) {
    //             hasErrors = true;
    //         }
    //     });

    //     setError(hasErrors);
    // }, [specs.fiders, objectsFiders, objects.pillars]);


    // useEffect(() => {
    //     const newObjectsFiders = []
    //     objectsFiders.forEach(f => {
    //         // const object1 = objects.pillars.find(p => p.fid === f.object_1_fid)
    //         const object1 = f.object1
    //         const object2 = f.object2
    //         // const object2 = objects.pillars.find(p => p.fid === f.object_2_fid)
    //         const { maxQuantity, typesFiders } = evalMaxQuantity(object1, object2);
    //         if (f.quantity !== maxQuantity) {
    //             let c = 0
    //             const mounted = f.mounted.map((m, i) => {
    //                 if ((c + m.quantity) <= f.quantity) {
    //                     c += m.quantity
    //                     return { ...m, quantity: m.quantity }
    //                 } else {
    //                     if (c < f.quantity) {
    //                         return { ...m, quantity: f.quantity - c }
    //                     } else {
    //                         return null
    //                     }
    //                 }
    //             }).filter(m => m !== null)
    //             setObjectsFiders(prev => prev.map(p => {
    //                 if (p.fid === f.fid) {
    //                     return {
    //                         ...p,
    //                         quantity: maxQuantity,
    //                         mounted,
    //                         mountedQuantity: mounted.reduce((sum, m) => sum + m.quantity, 0),
    //                         mounted: mounted
    //                     }
    //                 }
    //                 return p
    //             }))
    //         }
    //     })
    // }, [objects.pillars])



    // =================== ИНИЦИАЛИЗАЦИЯ ДАННЫХ ===================
    const initObjects = useCallback(() => {
        setIsLoading(true)
        // Инициализация объектов на основе переданных ID
        if (pillarsIds || zvzIds || opnIds || rlndIds || transformersIds || runnIds) {
            const newObjects = {
                pillars: [],
                zvz: [],
                opn: [],
                rlnd: [],
                transformers: [],
                runn: []
            };
            let newObjectsFiders = []
            const pillarsFiltered = pillars.filter(p => pillarsIds.includes(p.fid))
            // Обработка опор 04кВ
            if (pillarsIds) {
                newObjects.pillars = pillarsFiltered.map(p => {
                    const spec = specs.pillars.find(s => s.id === p.spec)

                    const mountedPillar = mounted.pillars?.find(mp => mp.fid === p.fid && mp.status > 0)
                    const isAlreadyMounted = specs.pillars.find(m => m.id === mountedPillar?.spec)
                    if ((!mode && !isAlreadyMounted) || p.name.includes('Сущ')) return null
                    return {
                        ...p,
                        spec: spec,
                        mounted: {
                            ...(isAlreadyMounted || spec),
                            retreat: mountedPillar?.retreat || ''
                        },
                        ktp: transformers.find(t => t.fid === Number(p.tp_id))
                    }
                }).filter(p => p);
            }

            // Обработка адаптеров ВЗ
            if (zvzIds) {
                newObjects.zvz = pillarsZvz.filter(p => zvzIds.includes(p.fid)).map(p => {
                    const spec = specs.zvz.find(s => s.id === p.spec)
                    const mountedZvz = mounted.zvz?.find(mp => mp.fid === p.fid && mp.status > 0)
                    const isAlreadyMounted = specs.zvz.find(m => m.id === mountedZvz?.spec)
                    const pillar = pillars.find(pill => pill.fid.toString() === p.closest_pillar_id.toString())
                    if (!mode && !isAlreadyMounted) return null
                    return {
                        ...p,
                        name: pillar?.name,
                        short_name: pillar?.short_name,
                        spec: spec,
                        mounted: {
                            ...(isAlreadyMounted || spec),
                            retreat: mountedZvz?.retreat || ''
                        },
                        ktp: transformers.find(t => t.fid === Number(p.tp_id))
                    }
                }).filter(p => p);
            }

            // Обработка ОПН
            if (opnIds) {
                newObjects.opn = pillarsOpn.filter(p => opnIds.includes(p.fid)).map(p => {
                    const spec = specs.opn.find(s => s.id === p.spec)
                    const mountedOpn = mounted.opn?.find(mp => mp.fid === p.fid && mp.status > 0)
                    const isAlreadyMounted = specs.opn.find(m => m.id === mountedOpn?.spec)
                    const pillar = pillars.find(pill => pill.fid.toString() === p.closest_pillar_id.toString())
                    if (!mode && !isAlreadyMounted) return null
                    return {
                        ...p,
                        name: pillar?.name,
                        short_name: pillar?.short_name,
                        spec: spec,
                        mounted: {
                            ...(isAlreadyMounted || spec),
                            retreat: mountedOpn?.retreat || ''
                        },
                        ktp: transformers.find(t => t.fid === Number(p.tp_id))
                    }
                }).filter(p => p);
            }

            // Обработка РЛНД
            if (rlndIds) {
                newObjects.rlnd = pillarsRlnd.filter(p => rlndIds.includes(p.fid)).map(p => {
                    const spec = specs?.rlnd?.find(s => s.id === p.spec)
                    const mountedRlnd = mounted?.rlnd?.find(mp => mp.fid === p.fid && mp.status > 0)
                    const isAlreadyMounted = specs?.rlnd?.find(m => m.id === mountedRlnd?.spec)
                    const pillar = pillars.find(pill => pill.fid.toString() === p.closest_pillar_id.toString())
                    if (!mode && !isAlreadyMounted) return null
                    return {
                        ...p,
                        name: pillar?.name,
                        short_name: pillar?.short_name,
                        spec: spec,
                        mounted: {
                            ...(isAlreadyMounted || spec),
                            retreat: mountedRlnd?.retreat || ''
                        },
                        ktp: transformers.find(t => t.fid === Number(p.tp_id))
                    }
                }).filter(p => p);
            }

            // Обработка трансформаторов
            if (transformersIds) {
                newObjects.transformers = transformers.filter(t => transformersIds.includes(t.fid)).map(t => {
                    console.log(t)
                    const spec = specs?.transformers?.find(s => s.id === t.spec)
                    const mountedTransformer = mounted?.transformers?.find(mt => mt.fid === t.fid && mt.status > 0)
                    const isAlreadyMounted = specs?.transformers?.find(m => m.id === mountedTransformer?.spec)
                    if (!mode && !isAlreadyMounted) return null
                    return {
                        ...t,
                        spec: spec,
                        mounted: {
                            ...(isAlreadyMounted || spec),
                            retreat: mountedTransformer?.retreat || ''
                        }
                    }
                }).filter(t => t);
            }

            // Обработка РУНН
            if (runnIds) {
                newObjects.runn = pillarsRunn.filter(p => runnIds.includes(p.fid)).map(p => {
                    const spec = specs?.runn?.find(s => s.id === p.spec)
                    const mountedRunn = mounted?.runn?.find(mp => mp.fid === p.fid && mp.status > 0)
                    const isAlreadyMounted = specs?.runn?.find(m => m.id === mountedRunn?.spec)
                    const transformer = transformers.find(tr => tr.fid.toString() === p.tp_id.toString())
                    if (!mode && !isAlreadyMounted) return null
                    return {
                        ...p,
                        name: transformer?.name,
                        short_name: '',
                        spec: spec,
                        mounted: {
                            ...(isAlreadyMounted || spec),
                            retreat: mountedRunn?.retreat || ''
                        },
                        ktp: transformer
                    }
                }).filter(p => p);
            }

            if (fiderIds) {
                fiderIds.forEach(({ id: fiderid, segments: fiderSegments }) => {
                    console.log(fiderid, fiderSegments)
                    const fider = fiders.find(f => f.id === fiderid)
                    if (!fider) return null
                    const mountedFider = mounted.fiders?.find(m => m.fid === fider.id)
                    if (!mode && !mountedFider) return
                    // const combined = fider.type === 'fider10-04'

                    // const left = fider.connected[0]
                    // const right = fider.connected[fider.connected.length - 1]

                    // const leftObject = left.type === 'pillar' ? pillars.find(p => p.fid === left.id) : transformers.find(p => p.fid === left.id)
                    // const rightObject = right.type === 'pillar' ? pillars.find(p => p.fid === right.id) : transformers.find(p => p.fid === right.id)

                    // const leftObjectМount = left.type === 'pillar' ? specs.pillars?.find(m => (m.id === mounted.pillars?.find(mp => mp.fid === leftObject.fid && mp.status >= 0)?.spec) || (m.id === leftObject.spec)) : null
                    // const rightObjectМount = right.type === 'pillar' ? specs.pillars?.find(m => (m.id === mounted.pillars?.find(mp => mp.fid === rightObject.fid && mp.status >= 0)?.spec) || (m.id === rightObject.spec)) : null

                    const objects = fider.connected.map(conn => {
                        if (!conn) return null
                        const obj = conn.type === 'pillar' ? pillars.find(p => p.fid === conn.id) : transformers.find(p => p.fid === conn.id)
                        if (!obj) return null
                        return {
                            ...obj,
                            mount: conn.type === 'pillar' ? specs.pillars?.find(m => (m.id === mounted.pillars?.find(mp => mp.fid === obj.fid && mp.status >= 0)?.spec) || (m.id === obj.spec)) : null
                        }
                    })
                    console.log(objects)
                    console.log(fiderSegments)
                    const distances = []
                    const coordinates = fider.coordinates
                    for (let i = 0; i < coordinates.length - 1; i++) {
                        const from = new L.LatLng(coordinates[i][0], coordinates[i][1]);
                        const to = new L.LatLng(coordinates[i + 1][0], coordinates[i + 1][1]);
                        distances.push(Math.round(from.distanceTo(to) * 100) / 100);
                    }
                    // const length = distances.reduce((a, v) => a + v, 0)
                    // const segm = {}

                    const segmentKeys = fiderSegments.map((fs) => (`${fider.connected[fs]?.type}_${fider.connected[fs]?.id}_${fider.connected[fs + 1]?.type}_${fider.connected[fs + 1]?.id}`))
                    let mount = mountedFider?.state
                    segmentKeys.forEach((key, index) => {
                        console.log(key, index)
                        if (!mode && (!mountedFider || mount.segments[key]?.status === 0)) return
                        if (mount?.segments?.[key]) {
                            newObjectsFiders.push({
                                fid: fider.id,
                                key,
                                distance: distances[fiderSegments[index]],
                                leftObject: objects[fiderSegments[index]],
                                rightObject: objects[fiderSegments[index] + 1],
                                type: fider.type,
                                combined: fider.type === 'fider10-04',
                                ...mount.segments[key],
                                status: mode ? 1 : 0
                            })
                        } else {
                            if (mode) {
                                newObjectsFiders.push({
                                    fid: fider.id,
                                    key,
                                    distance: distances[fiderSegments[index]],
                                    leftObject: objects[fiderSegments[index]],
                                    rightObject: objects[fiderSegments[index] + 1],
                                    type: fider.type,
                                    combined: fider.type === 'fider10-04',
                                    length: distances[fiderSegments[index]],
                                    sip_class: fider.sip_class?.map(sp => sp.id || null) || [],
                                    progress: 1,
                                    status: 1
                                })
                            }

                        }
                    })
                    // console.log(distances)
                    // if (mode && !mount) {
                    //     distances.forEach((distance, index) => {
                    //         const key = `${fider.connected[index].type}_${fider.connected[index].id}_${fider.connected[index + 1].type}_${fider.connected[index + 1].id}`
                    //         segm[key] = {
                    //             length: distance,
                    //             sip_class: fider.sip_class.map(sp => sp.id || null),
                    //             progress: 1,
                    //             status: segmentKeys.has(key) ? 1 : 0
                    //         }
                    //     })
                    //     mount = {
                    //         segments: segm
                    //     }
                    // }
                    // if (!mode && mount) {
                    //     const newMount = [...mount]
                    //     Object.entries(mount.segments).map((key, value) => {
                    //         if (segmentKeys.has(key) && value.status === 1) {
                    //             newMount.segments = {
                    //                 ...newMount.segments,
                    //                 [key]: {
                    //                     ...newMount.segments[key],
                    //                     status: 0
                    //                 }
                    //             }
                    //         }
                    //     })
                    // }

                    // console.log(fider)
                    // console.log(fiderSegments)
                    // return {
                    //     fid: fider.id,
                    //     fiderSegments: segmentKeys,
                    //     objects,
                    //     leftObject: objects[0],
                    //     rightObject: objects[objects.length - 1],
                    //     type: fider.type,
                    //     combined: fider.type === 'fider10-04',
                    //     length: length,
                    //     distances: distances,
                    //     sip_class: fider.sip_class.map(sp => sp.id || null),
                    //     mount: mountedFider ? mountedFider.state : {

                    //     },
                    //     connected: fider.connected
                    // }
                })
            }

            // Обработка фидеров между опорами
            // const pillarsUniqueIds = [...new Set(pillarsFiltered.map(p => p.fid))]
            // console.log(fiders)
            // const fidersFiltered = fiders.filter(f => (f.stage === '4' || f.stage === '3') && pillarsUniqueIds.some(pui => f.connected?.find(c => c && c.type === 'pillar' && c.id === pui)))
            // console.log(fidersFiltered)
            // fidersFiltered.forEach(f => {

            //     // const connec = f.connected
            //     // let connectedObjects = []
            //     // for (let index = 0; index < f.connected.length - 1; index++) {
            //     //     if (!f.connected[index] || !f.connected[index + 1]) continue;
            //     //     if (f.connected[index].id === f.connected[index + 1].id) continue;
            //     //     connectedObjects.push([f.connected[index], f.connected[index + 1], index])
            //     // }
            //     const mountedFider = mounted.fiders.find(m => m.fid === f.id)
            //     const combined = f.type === 'fider10-04'

            //     const left = f.connected[0]
            //     const right = f.connected[f.connected.length - 1]

            //     const leftObject = left.type === 'pillar' ? pillars.find(p => p.fid === left.id) : transformers.find(p => p.fid === left.id)
            //     const rightObject = right.type === 'pillar' ? pillars.find(p => p.fid === right.id) : transformers.find(p => p.fid === right.id)

            //     const distances = []
            //     const coordinates = f.coordinates
            //     for (let i = 0; i < coordinates.length - 1; i++) {
            //         const from = new L.LatLng(coordinates[i][0], coordinates[i][1]);
            //         const to = new L.LatLng(coordinates[i + 1][0], coordinates[i + 1][1]);
            //         distances.push(from.distanceTo(to));
            //     }
            //     const length = distances.reduce((a, v) => a + v, 0)

            //     if (mountedFider) {

            //     }
            //     newObjectsFiders.push({
            //         fid: f.id,
            //         leftObject,
            //         rightObject,
            //         type: f.type,
            //         length: length,
            //         sipClass: f.sip_class,
            //         mount: mountedFider ? mountedFider.state : {
            //             progress: 1,
            //             length: length,
            //             sip_class: f.sip_class
            //         },
            //         connected: f.connected
            //     })

            //     // Создание сегментов фидеров
            //     // connectedObjects.map(cp => {
            //     //     console.log(cp)
            //     //     // const isAlreadyMounted = mounted.fiders.find(m => m.fid === f.id && m.object_1_fid === cp[0].id && m.object_2_fid === cp[1].id && m.status > 0)
            //     //     const key = `${cp[0].type}_${cp[0].id}_${cp[1].type}_${cp[1].id}`
            //     //     const mountedFiderSegment = mountedFider?.state?.[key]


            //     //     // console.log(isAlreadyMounted)
            //     //     // if (!mode && !isAlreadyMounted) return null
            //     //     if (mountedFiderSegment) {
            //     //         const object1 = cp[0].type === 'pillar' ? pillarsFiltered.find(p => p.fid === cp[0].id) : transformers.find(p => p.fid === cp[0].id)
            //     //         const object2 = cp[1].type === 'pillar' ? pillarsFiltered.find(p => p.fid === cp[1].id) : transformers.find(p => p.fid === cp[1].id)
            //     //         console.log(object1, object2)
            //     //         const distance = object1?.connected?.find(c => c.id === object2.fid)?.distance || object2?.connected?.find(c => c.id === object1.fid)?.distance || 0



            //     //         if (object1 && object2) {
            //     //             // const spec = specs.fiders.find(s => s.id === f.spec)


            //     //             // let allowedSpecs = specs.fiders.filter(s => s.name.includes('СИП-'));
            //     //             // if (object1?.type === 'pillar04' || object2?.type === 'pillar04') {
            //     //             //     allowedSpecs = specs.fiders.filter(s => s.name.includes('СИП-2') || s.name.includes('СИП-4'));
            //     //             // } else if (object1?.type === 'pillar10' || object2?.type === 'pillar10') {
            //     //             //     allowedSpecs = specs.fiders.filter(s => s.name.includes('СИП-3'));
            //     //             // } else if (object1?.type === 'pillar04-10' && object2?.type === 'pillar04-10') {
            //     //             //     allowedSpecs = specs.fiders.filter(s => s.name.includes('СИП-'));
            //     //             // }

            //     //             newObjectsFiders.push({
            //     //                 fid: mountedFider.fid,
            //     //                 // pillars: [object1.fid, object2.fid],
            //     //                 object1: {
            //     //                     ...object1,
            //     //                     mounted: cp[0].type === 'pillar' ? specs.pillars.find(m => m.id === mounted.pillars.find(mp => mp.fid === object1.fid && mp.mount_stage >= 0)?.spec) : specs.pillars.find(s => s.id === object1.spec)
            //     //                 },
            //     //                 object2: {
            //     //                     ...object2,
            //     //                     mounted: cp[1].type === 'pillar' ? specs.pillars.find(m => m.id === mounted.pillars.find(mp => mp.fid === object2.fid && mp.mount_stage >= 0)?.spec) : specs.pillars.find(s => s.id === object1.spec)
            //     //                 },
            //     //                 key: key,
            //     //                 object_1_fid: object1.fid,
            //     //                 object_2_fid: object2.fid,
            //     //                 object_1_type: cp[0].type,
            //     //                 object_2_type: cp[1].type,
            //     //                 name: `${object1.name} - ${object2.name}`,
            //     //                 combined,
            //     //                 type: f.type,
            //     //                 sipClass: mountedFiderSegment.sip_class,
            //     //                 mounted: mountedFiderSegment.sip_class,
            //     //                 distance: distance,
            //     //                 mountedDistance: parseFloat(mountedFiderSegment.mountedDistance),
            //     //                 // spec: spec,
            //     //                 // allowedSpecs: allowedSpecs,
            //     //                 // mounted: isAlreadyMounted.data.mounted,
            //     //                 // quantity: parseFloat(isAlreadyMounted.data.quantity),
            //     //                 // mountedQuantity: parseFloat(isAlreadyMounted.data.mountedQuantity),
            //     //                 // distance: parseFloat(isAlreadyMounted.data.distance),
            //     //                 // mountedDistance: parseFloat(isAlreadyMounted.data.mountedDistance),
            //     //                 // retreat: isAlreadyMounted.data.retreat || ''
            //     //             })
            //     //         }
            //     //     } else {
            //     //         const object1 = cp[0].type === 'pillar' ? newObjects.pillars.find(p => p.fid === cp[0].id) : transformers.find(p => p.fid === cp[0].id)
            //     //         const object2 = cp[1].type === 'pillar' ? newObjects.pillars.find(p => p.fid === cp[1].id) : transformers.find(p => p.fid === cp[1].id)

            //     //         if (object1 && object2) {
            //     //             if (object1.fid === object2.fid) return;
            //     //             // const object1Chains = cp[0].type === 'pillar' ? object1.mounted.chains : Infinity
            //     //             // const object2Chains = cp[1].type === 'pillar' ? object2.mounted.chains : Infinity
            //     //             // Определение количества цепей
            //     //             // let quantity = Math.min(object1Chains, object2Chains)


            //     //             const distance = object1?.connected?.find(c => c.id === object2.fid)?.distance || object2?.connected?.find(c => c.id === object1.fid)?.distance || 0
            //     //             // const spec = specs.fiders.find(s => s.id === f.spec)

            //     //             // let allowedSpecs = specs.fiders.filter(s => s.name.includes('СИП-'));
            //     //             // if (object1?.type === 'pillar04' || object2?.type === 'pillar04') {
            //     //             //     allowedSpecs = specs.fiders.filter(s => s.name.includes('СИП-2') || s.name.includes('СИП-4'));
            //     //             // } else if (object1?.type === 'pillar10' || object2?.type === 'pillar10') {
            //     //             //     allowedSpecs = specs.fiders.filter(s => s.name.includes('СИП-3'));
            //     //             // } else if (object1?.type === 'pillar04-10' && object2?.type === 'pillar04-10') {
            //     //             //     allowedSpecs = specs.fiders.filter(s => s.name.includes('СИП-'));
            //     //             // }
            //     //             newObjectsFiders.push({
            //     //                 fid: f.id,
            //     //                 // pillars: [object1.fid, object2.fid],
            //     //                 object1,
            //     //                 object2,
            //     //                 key,
            //     //                 type: f.type,
            //     //                 combined,
            //     //                 object_1_fid: object1.fid,
            //     //                 object_2_fid: object2.fid,
            //     //                 object_1_type: cp[0].type,
            //     //                 object_2_type: cp[1].type,
            //     //                 name: `${object1.name} - ${object2.name}`,
            //     //                 sipClass: f.sip_class,
            //     //                 mounted: f.sip_class,
            //     //                 distance: distance,
            //     //                 mountedDistance: distance
            //     //                 // spec: spec,
            //     //                 // allowedSpecs: allowedSpecs,
            //     //                 // mounted: [{ ...spec, quantity: quantity }],
            //     //                 // quantity: quantity,
            //     //                 // mountedQuantity: quantity,
            //     //                 // distance: distance,
            //     //                 // mountedDistance: distance,
            //     //                 // justify: ''
            //     //             })
            //     //         }
            //     //     }
            //     // })
            // })
            setObjects(newObjects);
            setObjectsFiders(newObjectsFiders)
            console.log(newObjects)
            // =================== ИНИЦИАЛИЗАЦИЯ СОСТОЯНИЯ ЧЕКБОКСОВ ===================
            const initialSelectedItems = { pillars: {}, zvz: {}, opn: {}, rlnd: {}, transformers: {}, runn: {} };
            const initialDisabledItems = { pillars: {}, zvz: {}, opn: {}, rlnd: {}, transformers: {}, runn: {} };
            const initialDefaultSelectedItems = { pillars: {}, zvz: {}, opn: {}, rlnd: {}, transformers: {}, runn: {} };
            const initialDefaultDisabledItems = { pillars: {}, zvz: {}, opn: {}, rlnd: {}, transformers: {}, runn: {} };

            // Рекурсивная функция для обработки комплектации
            function childComplect(type, pillarId, compl, id = '') {
                if (!compl) return;
                if (compl) {
                    compl.forEach(c => {
                        const itemId = id ? `${id}_${c.id}` : `${c.id}`;
                        if (!initialSelectedItems[type][pillarId]) {
                            initialSelectedItems[type][pillarId] = [];
                        }
                        initialSelectedItems[type][pillarId].push(itemId);
                        if (c.complect) {
                            childComplect(type, pillarId, c.complect, itemId);
                        }
                    });
                }
            }

            // Обработка каждого типа объектов для инициализации состояния
            Object.entries(newObjects).forEach(([type, items]) => {
                items.forEach(pillar => {
                    if (!initialSelectedItems[type][pillar.fid]) {
                        initialSelectedItems[type][pillar.fid] = [];
                    }
                    if (!initialDisabledItems[type][pillar.fid]) {
                        initialDisabledItems[type][pillar.fid] = [];
                    }
                    // Инициализация defaultSelectedItems и defaultDisabledItems для всех объектов
                    if (!initialDefaultSelectedItems[type][pillar.fid]) {
                        initialDefaultSelectedItems[type][pillar.fid] = [];
                    }
                    if (!initialDefaultDisabledItems[type][pillar.fid]) {
                        initialDefaultDisabledItems[type][pillar.fid] = [];
                    }
                    if (pillar.spec?.complect_filtered) {
                        pillar.spec.complect_filtered.forEach(cf => {
                            childComplect(type, pillar.fid, cf.complect);
                        });
                    }
                });
            });

            // Обновление счетчиков выбранных элементов
            Object.entries(initialSelectedItems).forEach(([type, items]) => {
                Object.entries(items).forEach(([objectId, selectedItems]) => {
                    setSelectedItemsLengths(prev => ({
                        ...prev,
                        [`${type}_${objectId}`]: selectedItems.length
                    }));
                });
            });

            // Инициализация метаданных элементов (date, userid)
            const initialItemMetadata = { pillars: {}, zvz: {}, opn: {}, rlnd: {}, transformers: {}, runn: {} };
            console.log(mounted)
            // Обработка уже смонтированных элементов
            Object.entries(newObjects).forEach(([type, items]) => {
                items.forEach(object => {
                    const mountedItem = mounted[type]?.find(m => m.fid === object.fid && m.status > 0);
                    if (mountedItem) {
                        // Инициализируем метаданные для этого объекта
                        if (!initialItemMetadata[type][object.fid]) {
                            initialItemMetadata[type][object.fid] = {};
                        }

                        // Обрабатываем state - может быть строкой JSON или объектом
                        let state = mountedItem.state || {};
                        if (typeof state === 'string') {
                            try {
                                state = JSON.parse(state);
                            } catch (e) {
                                console.error('Error parsing state:', e);
                                state = {};
                            }
                        }

                        // Сохраняем метаданные (date, userid) для каждого элемента
                        Object.entries(state).forEach(([itemId, itemData]) => {
                            if (itemData && typeof itemData === 'object') {
                                initialItemMetadata[type][object.fid][itemId] = {
                                    date: itemData.date || null,
                                    userid: itemData.userid || null
                                };
                            }
                        });

                        initialDisabledItems[type][object.fid] = Object.entries(state).filter(([key, value]) => !value?.selected).map(([key]) => key) || [];
                        initialSelectedItems[type][object.fid] = Object.entries(state).filter(([key, value]) => value?.selected).map(([key]) => key) || [];

                        if (!initialDefaultSelectedItems[type][object.fid]) {
                            initialDefaultSelectedItems[type][object.fid] = [];
                        }
                        if (!initialDefaultDisabledItems[type][object.fid]) {
                            initialDefaultDisabledItems[type][object.fid] = [];
                        }

                        initialDefaultDisabledItems[type][object.fid] = Object.entries(state).filter(([key, value]) => !value?.selected).map(([key]) => key) || [];
                        initialDefaultSelectedItems[type][object.fid] = Object.entries(state).filter(([key, value]) => value?.selected).map(([key]) => key) || [];


                        // initialDisabledItems[type][object.fid] = mountedItem.not_mounted || [];
                        // initialSelectedItems[type][object.fid] = mountedItem.mounted || [];

                        // if (!initialDefaultSelectedItems[type][object.fid]) {
                        //     initialDefaultSelectedItems[type][object.fid] = [];
                        // }
                        // if (!initialDefaultDisabledItems[type][object.fid]) {
                        //     initialDefaultDisabledItems[type][object.fid] = [];
                        // }

                        // initialDefaultDisabledItems[type][object.fid] = mountedItem.not_mounted || [];
                        // initialDefaultSelectedItems[type][object.fid] = mountedItem.mounted || [];
                    }
                });
            });
            console.log(initialDefaultSelectedItems, initialDefaultDisabledItems)
            setSelectedItems(initialSelectedItems);
            setDisabledItems(initialDisabledItems);
            setDefaultSelectedItems(initialDefaultSelectedItems);
            setDefaultDisabledItems(initialDefaultDisabledItems);
            console.log(initialItemMetadata)
            setItemMetadata(initialItemMetadata);
            setIsLoading(false)
        }
    }, [pillarsIds, zvzIds, opnIds, rlndIds, transformersIds, runnIds, pillars, pillarsZvz, pillarsOpn, pillarsRlnd, pillarsRunn, transformers, fiders, specs]);

    // Вызов инициализации при изменении данных
    useEffect(() => {
        initObjects()
    }, [])

    // Автоматическое переключение на первый доступный таб
    useEffect(() => {
        const hasObjects = Object.values(objects).some(arr => arr.length > 0);
        const hasFiders = objectsFiders.length > 0;

        if (hasObjects && hasFiders) {
            // Если есть и объекты, и фидеры, оставляем текущий таб
            return;
        } else if (hasObjects && !hasFiders) {
            // Если есть только объекты, переключаемся на таб объектов
            setActiveTab(0);
        } else if (!hasObjects && hasFiders) {
            // Если есть только фидеры, переключаемся на таб фидеров
            setActiveTab(1);
        }
    }, [objects, objectsFiders]);

    // =================== ОБРАБОТЧИКИ ===================
    // Изменение типа объекта
    const handleChangeType = (type_id, group, pillar) => {
        if (group === 'pillarsPairs') {
            const newSpec = specs.fiders.find(t => t.id === type_id);
            setObjectsFiders(prev => (prev.fiders.map(p => {
                if (p.fid === pillar.fid && p.pillar1 === pillar.pillar1 && p.pillar2 === pillar.pillar2) {
                    return { ...p, mounted: newSpec }
                }
                return p
            })
            ))
            return;
        }

        // Для обычных объектов используем внутреннюю логику из ObjectsTable
        if (objectsTableRef.current?.handleChangeType) {
            objectsTableRef.current.handleChangeType(type_id, group, pillar);
        }
    };


    // =================== ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ ===================
    // Проверка на полную комплектацию категории
    const isCategoryAllChecked = (pillarType, pillarId, category) => {
        return !disabledItems[pillarType]?.[pillarId]?.find(i =>
            category.complect.find(c => i === `${c.id}` || i.startsWith(`${c.id}_`))
        );
    };

    // Проверка полноты комплектации опоры
    const isPillarComplectFull = (pillar) => {
        return pillar.mounted.complect_filtered.every(cf =>
            cf.complect.every(c => {
                return !c.isMounted
            })
        );
    };

    // Сброс к настройкам по умолчанию
    const handleResetToDefault = () => {
        initObjects()
        setDisabledObjects({})
        setResetKey(prev => prev + 1) // Принудительный перерендер компонентов

    };

    // Выбор/снятие всех элементов для опоры
    const handleSelectAll = (pillar, checked) => {
        // Определение типа опоры
        const pillarType = Object.entries(objects).find(([_, items]) =>
            items.some(p => p.fid === pillar.fid)
        )?.[0];

        if (!pillarType) return;

        if (checked) {
            const toEnable = disabledItems[pillarType]?.[pillar.fid] || [];
            setSelectedItems(prev => ({
                ...prev,
                [pillarType]: {
                    ...prev[pillarType],
                    [pillar.fid]: toEnable
                }
            }));
            setDisabledItems(prev => ({
                ...prev,
                [pillarType]: {
                    ...prev[pillarType],
                    [pillar.fid]: []
                }
            }));
        } else {
            const toDisable = selectedItems[pillarType]?.[pillar.fid] || [];
            setDisabledItems(prev => ({
                ...prev,
                [pillarType]: {
                    ...prev[pillarType],
                    [pillar.fid]: toDisable
                }
            }));
            setSelectedItems(prev => ({
                ...prev,
                [pillarType]: {
                    ...prev[pillarType],
                    [pillar.fid]: []
                }
            }));
        }
    };


    // =================== ФУНКЦИЯ ОТПРАВКИ ДАННЫХ ===================
    const handleSend = async () => {
        setOpenConfirmDialog(false)
        setIsLoading(true)
        const errors = {
            pillars: [],
            opn: [],
            zvz: [],
            rlnd: [],
            transformers: [],
            runn: [],
            fiders: [],
        }
        // Формирование объекта для отправки
        const toUpdate = {
            pillars: {},
            opn: {},
            zvz: {},
            rlnd: {},
            transformers: {},
            runn: {},
            fiders: {}
        }

        let hasErrors = false;

        


        // Получаем обновленные данные от дочерних компонентов
        const updatedObjects = objectsTableRef.current?.getUpdatedData() || objects;
        const updatedObjectsFiders = objectsFidersTableRef.current?.getUpdatedData() || objectsFiders;
        console.log(updatedObjects)
        
        Object.entries(updatedObjects).forEach(([key, value]) => {
            if (key && value && !disabledObjects[key]?.find(id => id === value.fid))
            value.forEach(p => {
                if (p.spec.id !== p.mounted.id && (!p.mounted.retreat || p.mounted.retreat === '')) {
                    hasErrors = true;
                }
            })
        })
        // updatedObjectsFiders.forEach(f => {

        //     const isQuantityInsufficient = f.mountedQuantity < f.mounted.reduce((sum, m) => sum + m.quantity, 0);

        //     if (isQuantityInsufficient) {
        //         hasErrors = true;
        //     }
        // });
        if (hasErrors) {
            setErrorAlertMessage('Есть незаполненные данные');
            setShowErrorAlert(true);
            setIsLoading(false);
            setTimeout(() => {
                setShowErrorAlert(false);
                setErrorAlertMessage('');
            }, 3000);
            return;
        }

        // Собираем все данные для отправки одним пакетом
        const batchData = [];

        // Обрабатываем все объекты (pillars, opn, zvz, rlnd, transformers, runn)
        Object.keys(updatedObjects).forEach(type => {
            updatedObjects[type].forEach(object => {
                if (disabledObjects[type]?.find(id => id === object.fid)) {
                    return;
                }

                let selectedItemsForObject = selectedItems[type]?.[object.fid] || [];
                let disablesItemsForObject = disabledItems[type]?.[object.fid] || [];

                //TODO: стадия монтирования в зависимости от выбранных и отклоненных спецификаций а не от режима
                let mountStage = 0;
                if (mode) {
                    if (selectedItemsForObject.length === 0) {
                        mountStage = 0; // Не смонтировано
                    } else if (disablesItemsForObject.length === 0) {
                        mountStage = 2 // Полностью смонтировано
                    } else {
                        mountStage = 1; // Частично смонтировано
                    }
                } else {
                    disablesItemsForObject = [...disablesItemsForObject, ...selectedItemsForObject]
                    selectedItemsForObject = []
                    mountStage = 0
                }
                // if(mountStage > 0 && object.spec?.id !== object.mounted?.id) {
                //     mountStage = mountStage + 2
                // }

                const state = {}
                const mountedItem = mounted[type]?.find(m => m.fid === object.fid && m.status > 0)
                const mountedItemState = mountedItem?.state || {}

                selectedItemsForObject.map(item => {
                    const itemState = mountedItemState[item]
                    const isChangedCompareWithDefault = !itemState?.selected
                    state[item] = {
                        selected: true,
                        userid: isChangedCompareWithDefault ? user.id : (itemState?.userid || null),
                        date: isChangedCompareWithDefault ? new Date(executionDateTime).getTime() : (itemState?.date || null),
                    }
                })

                disablesItemsForObject.map(item => {
                    const itemState = mountedItemState[item]
                    const isChangedCompareWithDefault = !mountedItem || itemState?.selected
                    state[item] = {
                        selected: false,
                        userid: isChangedCompareWithDefault ? user.id : (itemState?.userid || null),
                        date: isChangedCompareWithDefault ? new Date(executionDateTime).getTime() : (itemState?.date || null),
                    }
                })

                const data = {
                    fid: object.fid,
                    type: type,
                    spec: object.mounted?.id || null,
                    state: state,
                    status: mountStage,
                    retreat: object.mounted?.retreat || '',
                    user_id: user.id,
                    date: executionDateTime ? new Date(executionDateTime).toISOString() : null
                }

                batchData.push(data);
            });
        });

        // Обрабатываем фидеры
        const updatedFiders = [...new Set(updatedObjectsFiders.map(f => f.fid))]
        updatedFiders.forEach(fid => {
            const newMount = {}
            updatedObjectsFiders.filter(f => f.fid === fid && f.key && !disabledObjects.fiders?.find(dis => dis === `${f.fid}_${f.key}`)).forEach(f => {
                newMount[f.key] = {
                    length: f.length,
                    progress: f.progress,
                    status: f.status,
                    sip_class: f.sip_class,
                    userid: user.id,
                    date: new Date(executionDateTime).getTime()
                }
            })
            
            // Пропускаем фидер, если нет выбранных сегментов (newMount пустой)
            // Это означает, что все сегменты отключены
            if (Object.keys(newMount).length === 0) {
                return;
            }
            
            const oldMount = mounted?.fiders?.find(f => f.fid === fid) || {}
            const data = {
                fid: fid,
                type: 'fiders',
                spec: null,
                state: { segments: { ...(oldMount?.state?.segments || {}), ...newMount } },
                status: mode ? 1 : 0,
                retreat: '',
                user_id: user.id,
                date: executionDateTime ? new Date(executionDateTime).toISOString() : null
            }
            batchData.push(data);
        });
        console.log(batchData)
        
        // Отправляем все данные одним запросом
        if (batchData.length > 0) {
        // if (false) {
            try {
                const res = await $authHost.post(`/apig/execution/batch`, { data: batchData });

                if (!res?.data?.success) {
                    // Если запрос не успешен, добавляем все объекты в ошибки
                    batchData.forEach(data => {
                        const type = data.type === 'fider' ? 'fiders' : data.type;
                        if (type === 'fiders') {
                            errors.fiders.push(data.fid)
                        } else {
                            const object = updatedObjects[type]?.find(o => o.fid === data.fid);
                            if (object) {
                                errors[type].push(object.name)
                            }
                        }
                    });
                }
            } catch (error) {
                // При ошибке добавляем все объекты в ошибки
                batchData.forEach(data => {
                    const type = data.type === 'fider' ? 'fiders' : data.type;
                    if (type === 'fiders') {
                        errors.fiders.push(data.fid)
                    } else {
                        const object = updatedObjects[type]?.find(o => o.fid === data.fid);
                        if (object) {
                            errors[type].push(object.name)
                        }
                    }
                });
            }
        }
        
        setIsLoading(false)



        if (Object.values(errors).flat().length > 0) {
            Object.entries(errors).forEach(([type, errors]) => {
                console.log(type, errors)
                switch (type) {
                    case 'pillars':
                        setErrorAlertMessage(prev => prev + '\nОшибка при отправке опор: ' + errors.join(', '));
                        break;
                    case 'opn':
                        setErrorAlertMessage(prev => prev + '\nОшибка при отправке ОПН: ' + errors.join(', '));
                        break;
                    case 'zvz':
                        setErrorAlertMessage(prev => prev + '\nОшибка при отправке комплекта адаптеров ВЗ: ' + errors.join(', '));
                        break;
                    case 'rlnd':
                        setErrorAlertMessage(prev => prev + '\nОшибка при отправке РЛНД: ' + errors.join(', '));
                        break;
                    case 'transformers':
                        setErrorAlertMessage(prev => prev + '\nОшибка при отправке трансформаторов: ' + errors.join(', '));
                        break;
                    case 'runn':
                        setErrorAlertMessage(prev => prev + '\nОшибка при отправке РУНН: ' + errors.join(', '));
                        break;
                    case 'fiders':
                        setErrorAlertMessage(prev => prev + '\nОшибка при отправке пролетов: ' + errors.join(', '));
                        break;
                }
            });
            setShowErrorAlert(true);

        } else {
            // dispatch(updateMounted(toUpdate))
            dispatch(fetchMounted());
            dispatch(fetchState());
            setShowSuccessAlert(true);
        }

        // Автоматическое скрытие уведомлений
        setTimeout(() => {
            setShowSuccessAlert(false);
            setShowErrorAlert(false);
            setErrorAlertMessage('');
        }, 3000);

        // Закрытие модального окна через 2 секунды после успешной отправки
        setTimeout(() => {
            dispatch(setModal(null));
        }, 2000);
    };

    // =================== ОБРАБОТЧИКИ УВЕДОМЛЕНИЙ ===================
    const handleCloseAlert = () => {
        setShowSuccessAlert(false)
        setShowErrorAlert(false)
    };


    // =================== ОСНОВНОЙ РЕНДЕР ===================
    return (
        <>
            {/* =================== ОСНОВНОЙ ДИАЛОГ =================== */}
            <Dialog
                open={true}
                onClose={smallMode ? () => { } : handleClose} // Отключаем закрытие в smallMode
                fullScreen={smallMode}
                maxWidth={smallMode ? "sm" : "lg"}
                fullWidth
                hideBackdrop={smallMode} // Полностью убираем backdrop в small режиме
                TransitionComponent={Fade}
                transitionDuration={300}
                slotProps={{
                    backdrop: {
                        sx: {
                            display: smallMode ? 'none' : 'block',
                            backgroundColor: darkMode ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.5)',
                            pointerEvents: smallMode ? 'none' : 'auto' // Пропускаем события в small режиме
                        }
                    },
                    paper: {
                        sx: {
                            bgcolor: darkMode ? '#1e1e1e' : '#fff',
                            color: darkMode ? '#f5f7fa' : '#333',
                            ...(smallMode ? {
                                // Позиционирование в small режиме: перетаскиваемое
                                position: 'fixed',
                                top: `${windowPosition.y}px`,
                                left: `${windowPosition.x}px`,
                                width: `${windowSize.width}px`,
                                height: `${windowSize.height}px`,
                                margin: 0,
                                borderRadius: '12px',
                                pointerEvents: 'auto', // Диалог сам принимает события
                                zIndex: 1300,
                                cursor: isDragging ? 'grabbing' : 'grab',
                                userSelect: 'none',
                                resize: 'none',
                                overflow: 'hidden',
                                display: 'flex',
                                flexDirection: 'column',
                                boxShadow: darkMode
                                    ? '0 8px 32px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.1)'
                                    : '0 8px 32px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)'
                            } : {
                                // Обычное позиционирование для полного режима
                                width: '80%',
                                maxWidth: '90%',
                                height: '90vh',
                                maxHeight: '90vh',
                                borderRadius: '12px',
                                boxShadow: darkMode
                                    ? '0 8px 32px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.1)'
                                    : '0 8px 32px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)'
                            })
                        }
                    }
                }}
                sx={{
                    ...(smallMode && {
                        pointerEvents: 'none', // Контейнер диалога не блокирует события
                        '& .MuiDialog-paper': {
                            pointerEvents: 'auto' // Но сама бумага принимает события
                        },
                        '& .MuiTextField-root': {
                            pointerEvents: 'auto' // Поля ввода должны принимать события
                        },
                        '& .MuiInputBase-input': {
                            pointerEvents: 'auto' // Входные поля должны принимать события
                        }
                    })
                }}
                disableEscapeKeyDown={smallMode} // Отключаем закрытие по Escape в smallMode
                ref={dialogRef}
            >
                {/* =================== ЗАГОЛОВОК ДИАЛОГА =================== */}
                <DialogTitle sx={{
                    padding: '8px 12px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: darkMode
                        ? '1px solid rgba(255, 255, 255, 0.12)'
                        : '1px solid rgba(0, 0, 0, 0.12)',
                    backgroundColor: darkMode ? '#2b2b2b' : '#fff',
                    color: darkMode ? '#f5f7fa' : '#333',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    gap: 1,
                    position: 'relative',
                    ...(smallMode && {
                        cursor: isDragging ? 'grabbing' : 'grab',
                        userSelect: 'none'
                    })
                }}>
                    {/* Drag Handle для smallMode */}
                    {smallMode && (
                        <Box
                            sx={{
                                // position: 'absolute',

                                // left: '8px',
                                // top: '50%',
                                // transform: 'translateY(-50%)',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: isDragging ? 'grabbing' : 'grab',
                                padding: '4px',
                                borderRadius: '4px',
                                color: darkMode ? '#bbb' : '#666',
                                '&:hover': {
                                    backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                }
                            }}
                            onMouseDown={handleDragHandleMouseDown}
                        >
                            <DragIndicatorIcon fontSize="small" />
                        </Box>
                    )}
                    {/* Поле для ввода даты и времени выполнения */}
                    <TextField

                        type="datetime-local"
                        size="small"
                        label="Дата и время выполнения"
                        value={executionDateTime}
                        onChange={(e) => setExecutionDateTime(e.target.value)}
                        inputRef={executionDateTimeInputRef}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title="Открыть календарь" arrow placement="top">
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                const inputEl = executionDateTimeInputRef.current;
                                                if (!inputEl) return;
                                                // Chromium (Chrome/Edge): открывает нативный пикер программно
                                                if (typeof inputEl.showPicker === 'function') {
                                                    inputEl.showPicker();
                                                    return;
                                                }
                                                // Фоллбек
                                                inputEl.focus();
                                                inputEl.click();
                                            }}
                                            sx={{
                                                color: darkMode ? '#bbb' : '#666',
                                                '&:hover': {
                                                    color: darkMode ? '#f5f7fa' : '#333',
                                                    backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)',
                                                }
                                            }}
                                        >
                                            <EventIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            )
                        }}
                        sx={{
                            minWidth: '150px',
                            flexShrink: 0,
                            fontSize: '0.9rem',
                            '& .MuiInputBase-input': {
                                padding: '8px 12px',
                                color: darkMode ? '#f5f7fa' : '#333',
                                fontSize: '0.9rem',
                            },
                            // Для type="datetime-local" иконка/кнопка календаря нативная (браузерная),
                            // поэтому стили через .MuiIconButton-root на неё не действуют.
                            '& .MuiInputBase-input[type="datetime-local"]': {
                                // оставляем место под нашу кнопку (endAdornment)
                                paddingRight: '44px',
                                // Подсказываем браузеру, что контрол должен выглядеть "как в тёмной теме"
                                // (в поддерживаемых браузерах влияет на встроенные элементы управления).
                                colorScheme: darkMode ? 'dark' : 'light',
                            },
                            // Нативную иконку скрываем (она может оставаться чёрной и плохо стилится),
                            // вместо неё используем свою кнопку в endAdornment.
                            '& .MuiInputBase-input[type="datetime-local"]::-webkit-calendar-picker-indicator': {
                                opacity: 0,
                                pointerEvents: 'none',
                            },
                            '& .MuiIconButton-root': {
                                color: darkMode ? '#bbb' : '#666',
                                '&:hover': {
                                    bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                }
                            },
                            '& .MuiInputLabel-root': {
                                color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                fontSize: '0.9rem',
                            },
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: darkMode ? '#1e1e1e' : '#f8f9fa',
                                borderRadius: '8px',
                                '& fieldset': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                                    borderRadius: '8px',
                                },
                                '&:hover fieldset': {
                                    borderColor: darkMode ? 'rgba(100, 181, 246, 0.4)' : 'rgba(25, 118, 210, 0.4)',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                    borderWidth: '2px',
                                },
                            },

                        }}
                    />
                    {/* Поле поиска */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: '1 1 auto', minWidth: '100px', maxWidth: '400px' }}>
                        <TextField
                            // label="Поиск"
                            size="small"
                            placeholder="Поиск"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            sx={{
                                                color: darkMode ? '#bbb' : '#666',
                                                fontSize: '1.1rem'
                                            }}
                                        />
                                    </InputAdornment>
                                ),
                                endAdornment: searchText && (
                                    <InputAdornment position="end">
                                        <Tooltip title="Очистить поиск" arrow placement="top">
                                            <IconButton
                                                size="small"
                                                onClick={handleClearSearch}
                                                sx={{
                                                    color: darkMode ? '#bbb' : '#666',
                                                    padding: '2px',
                                                    '&:hover': {
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                                                    },
                                                }}
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                marginLeft: smallMode ? '40px' : '16px', // Увеличиваем отступ для drag handle
                                fontSize: '0.9rem',
                                flex: 1,
                                '& .MuiInputBase-input': {
                                    padding: '8px 12px',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    fontSize: '0.9rem',
                                },
                                '& .MuiInputLabel-root': {
                                    color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                    fontSize: '0.9rem',
                                },
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: darkMode ? '#1e1e1e' : '#f8f9fa',
                                    borderRadius: '8px',
                                    '& fieldset': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                                        borderRadius: '8px',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: darkMode ? 'rgba(100, 181, 246, 0.4)' : 'rgba(25, 118, 210, 0.4)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                        borderWidth: '2px',
                                    },
                                },
                            }}
                        />
                        <Tooltip
                            title={
                                searchInComplect
                                    ? 'Отключить поиск в комплектации'
                                    : 'Включить поиск в комплектации'
                            }
                            arrow
                            placement="top"
                        >
                            <IconButton
                                size="small"
                                onClick={() => setSearchInComplect(!searchInComplect)}
                                sx={{
                                    color: searchInComplect
                                        ? (darkMode ? '#4caf50' : '#2e7d32')
                                        : (darkMode ? '#bbb' : '#666'),
                                    backgroundColor: searchInComplect
                                        ? (darkMode ? 'rgba(76, 175, 80, 0.1)' : 'rgba(46, 125, 50, 0.1)')
                                        : 'transparent',
                                    border: searchInComplect
                                        ? (darkMode ? '1px solid rgba(76, 175, 80, 0.3)' : '1px solid rgba(46, 125, 50, 0.3)')
                                        : (darkMode ? '1px solid rgba(255, 255, 255, 0.23)' : '1px solid rgba(0, 0, 0, 0.23)'),
                                    padding: '8px',
                                    borderRadius: '8px',
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        backgroundColor: searchInComplect
                                            ? (darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(46, 125, 50, 0.2)')
                                            : (darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'),
                                        transform: 'scale(1.05)',
                                    },
                                }}
                            >
                                {searchInComplect ? (
                                    <FilterListIcon fontSize="small" />
                                ) : (
                                    <FilterListOffIcon fontSize="small" />
                                )}
                            </IconButton>
                        </Tooltip>
                    </Box>
                    {/* Кнопки управления */}
                    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexShrink: 0 }}>
                        {/* Кнопка переключения темы */}
                        {/* <IconButton
                            size="small"
                            onClick={() => dispatch(toggleDarkMode())}
                            sx={{
                                color: darkMode ? '#64b5f6' : '#1976d2',
                                padding: '4px',
                                '&:hover': {
                                    backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.1)' : 'rgba(25, 118, 210, 0.1)',
                                },
                            }}
                        >
                            {darkMode ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
                        </IconButton> */}

                        {/* {smallMode && (
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={() => setSmallMode(false)}
                                sx={{
                                    color: darkMode ? '#64b5f6' : '#1976d2',
                                    borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                    minWidth: 'auto',
                                    padding: '4px 8px',
                                    fontSize: '0.75rem',
                                    '&:hover': {
                                        backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.1)' : 'rgba(25, 118, 210, 0.1)',
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                    },
                                }}
                            >
                                Развернуть
                            </Button>
                        )} */}

                        <Tooltip title="Сбросить к настройкам по умолчанию" arrow placement="top">
                            <IconButton
                                size="small"
                                onClick={handleResetToDefault}
                                sx={{
                                    color: darkMode ? '#ff9800' : '#f57c00',
                                    backgroundColor: darkMode ? 'rgba(255, 152, 0, 0.1)' : 'rgba(245, 124, 0, 0.1)',
                                    border: darkMode ? '1px solid rgba(255, 152, 0, 0.3)' : '1px solid rgba(245, 124, 0, 0.3)',
                                    padding: '6px',
                                    borderRadius: '6px',
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        backgroundColor: darkMode ? 'rgba(255, 152, 0, 0.2)' : 'rgba(245, 124, 0, 0.2)',
                                        borderColor: darkMode ? '#ffb74d' : '#ff9800',
                                        transform: 'scale(1.05)',
                                    },
                                }}
                            >
                                <RestoreIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {!smallMode ?
                            <Tooltip title="Переключить в компактный режим" arrow placement="top">
                                <IconButton
                                    size="small"
                                    onClick={() => setSmallMode(true)}
                                    sx={{
                                        color: darkMode ? '#9c27b0' : '#7b1fa2',
                                        backgroundColor: darkMode ? 'rgba(156, 39, 176, 0.1)' : 'rgba(123, 31, 162, 0.1)',
                                        border: darkMode ? '1px solid rgba(156, 39, 176, 0.3)' : '1px solid rgba(123, 31, 162, 0.3)',
                                        padding: '6px',
                                        borderRadius: '6px',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            backgroundColor: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(123, 31, 162, 0.2)',
                                            borderColor: darkMode ? '#ba68c8' : '#9c27b0',
                                            transform: 'scale(1.05)',
                                        },
                                    }}
                                >
                                    <FullscreenIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            :
                            <Tooltip title="Вернуться к обычному режиму" arrow placement="top">
                                <IconButton
                                    size="small"
                                    onClick={() => setSmallMode(false)}
                                    sx={{
                                        color: darkMode ? '#9c27b0' : '#7b1fa2',
                                        backgroundColor: darkMode ? 'rgba(156, 39, 176, 0.1)' : 'rgba(123, 31, 162, 0.1)',
                                        border: darkMode ? '1px solid rgba(156, 39, 176, 0.3)' : '1px solid rgba(123, 31, 162, 0.3)',
                                        padding: '6px',
                                        borderRadius: '6px',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            backgroundColor: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(123, 31, 162, 0.2)',
                                            borderColor: darkMode ? '#ba68c8' : '#9c27b0',
                                            transform: 'scale(1.05)',
                                        },
                                    }}
                                >
                                    <FullscreenExitIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        }
                    </Box>
                </DialogTitle>

                {/* =================== ОСНОВНОЕ СОДЕРЖИМОЕ =================== */}
                <DialogContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: smallMode ? '8px' : '12px',
                    overflow: 'auto',
                    flex: 1,
                    backgroundColor: darkMode ? '#1e1e1e' : '#f5f7fa',
                    color: darkMode ? '#f5f7fa' : '#333',
                }}>
                    {/* Табы для разделения таблиц */}
                    {(Object.values(objects).some(arr => arr.length > 0) || objectsFiders.length > 0) && (
                        <Tabs
                            value={activeTab}
                            onChange={handleTabChange}
                            sx={{
                                borderBottom: 1,
                                borderColor: darkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
                                marginBottom: 1,
                                minHeight: 'auto',
                                '& .MuiTab-root': {
                                    fontSize: smallMode ? '0.7rem' : '0.8rem',
                                    padding: smallMode ? '6px 12px' : '8px 16px',
                                    minHeight: smallMode ? '32px' : '36px',
                                    color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    '&.Mui-selected': {
                                        color: darkMode ? '#64b5f6' : '#1976d2',
                                        fontWeight: 600,
                                    },
                                    '&:hover': {
                                        color: darkMode ? '#f5f7fa' : '#1976d2',
                                        backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(25, 118, 210, 0.05)',
                                    },
                                },
                                '& .MuiTabs-indicator': {
                                    backgroundColor: darkMode ? '#64b5f6' : '#1976d2',
                                    height: 2,
                                    borderRadius: '1px 1px 0 0',
                                }
                            }}
                        >
                            {Object.values(objects).some(arr => arr.length > 0) && (
                                <Tab
                                    label={`Трансформаторы, Опоры, комплекты адаптеров ВЗ, комплекты ОПН, РЛНД, РУНН (${Object.values(objects).reduce((total, arr) => total + arr.length, 0)})`}
                                />
                            )}
                            {objectsFiders.length > 0 && (
                                <Tab
                                    label={`Фидеры (${objectsFiders.length})`}
                                />
                            )}
                        </Tabs>
                    )}

                    {/* Содержимое табов */}
                    {Object.values(objects).some(arr => arr.length > 0) && objectsFiders.length > 0 ? (
                        // Если есть и объекты, и фидеры - показываем табы
                        <>
                            <Box sx={{
                                display: activeTab === 0 ? 'flex' : 'none',
                                flex: 1,
                                transition: 'opacity 0.3s ease-in-out'
                            }}>
                                <ObjectsTable
                                    key={`objects-${Object.values(objects).reduce((total, arr) => total + arr.length, 0)}-${resetKey}`}
                                    ref={objectsTableRef}
                                    objects={objects}
                                    setObjects={setObjects}
                                    transformers={transformers}
                                    smallMode={smallMode}
                                    mode={mode}
                                    disabledObjects={disabledObjects}
                                    setDisabledObjects={setDisabledObjects}
                                    selectedItems={selectedItems}
                                    disabledItems={disabledItems}
                                    defaultSelectedItems={defaultSelectedItems}
                                    defaultDisabledItems={defaultDisabledItems}
                                    setSelectedItems={setSelectedItems}
                                    darkMode={darkMode}
                                    setDisabledItems={setDisabledItems}
                                    handleChangeType={handleChangeType}
                                    specs={specs}
                                    searchText={debouncedSearchText}
                                    searchInComplect={searchInComplect}
                                    selectObject={selectObject}
                                    map={map}
                                    itemMetadata={itemMetadata}
                                />
                            </Box>

                            <Box sx={{
                                display: activeTab === 1 ? 'flex' : 'none',
                                flex: 1,
                                transition: 'opacity 0.3s ease-in-out'
                            }}>
                                <ObjectsFidersTable
                                    key={`fiders-${objectsFiders.length}-${resetKey}`}
                                    ref={objectsFidersTableRef}
                                    objectsFiders={objectsFiders}
                                    setObjectsFiders={setObjectsFiders}
                                    smallMode={smallMode}
                                    mode={mode}
                                    disabledObjects={disabledObjects}
                                    setDisabledObjects={setDisabledObjects}
                                    searchText={debouncedSearchText}
                                    specs={specs.sip_class}
                                    // evalMaxQuantity={evalMaxQuantity}
                                    selectObjectFider={selectObjectFider}
                                    selectObject={selectObject}
                                    map={map}
                                    dialogRef={dialogRef}
                                    darkMode={darkMode}
                                />
                            </Box>
                        </>
                    ) : (
                        // Если есть только один тип данных - показываем без табов
                        <>
                            {Object.values(objects).some(arr => arr.length > 0) && (
                                <ObjectsTable
                                    key={`objects-${Object.values(objects).reduce((total, arr) => total + arr.length, 0)}-${resetKey}`}
                                    ref={objectsTableRef}
                                    objects={objects}
                                    setObjects={setObjects}
                                    transformers={transformers}
                                    smallMode={smallMode}
                                    mode={mode}
                                    disabledObjects={disabledObjects}
                                    setDisabledObjects={setDisabledObjects}
                                    selectedItems={selectedItems}
                                    disabledItems={disabledItems}
                                    defaultSelectedItems={defaultSelectedItems}
                                    defaultDisabledItems={defaultDisabledItems}
                                    setSelectedItems={setSelectedItems}
                                    darkMode={darkMode}
                                    setDisabledItems={setDisabledItems}
                                    handleChangeType={handleChangeType}
                                    specs={specs}
                                    searchText={debouncedSearchText}
                                    searchInComplect={searchInComplect}
                                    selectObject={selectObject}
                                    map={map}
                                    itemMetadata={itemMetadata}
                                />
                            )}

                            {objectsFiders.length > 0 && (
                                <ObjectsFidersTable
                                    key={`fiders-${objectsFiders.length}-${resetKey}`}
                                    ref={objectsFidersTableRef}
                                    objectsFiders={objectsFiders}
                                    setObjectsFiders={setObjectsFiders}
                                    smallMode={smallMode}
                                    mode={mode}
                                    disabledObjects={disabledObjects}
                                    setDisabledObjects={setDisabledObjects}
                                    searchText={debouncedSearchText}
                                    specs={specs.fiders.filter(s => s.name.includes('СИП-'))}
                                    // evalMaxQuantity={evalMaxQuantity}
                                    selectObjectFider={selectObjectFider}
                                    selectObject={selectObject}
                                    map={map}
                                    dialogRef={dialogRef}
                                    darkMode={darkMode}
                                />
                            )}
                        </>
                    )}
                </DialogContent>



                {/* =================== ФУТЕР ДИАЛОГА =================== */}
                <DialogActions sx={{
                    px: 1.5,
                    py: 1,
                    backgroundColor: darkMode ? '#2b2b2b' : '#fff',
                    borderTop: darkMode
                        ? '1px solid rgba(255, 255, 255, 0.12)'
                        : '1px solid rgba(0, 0, 0, 0.12)',
                    gap: 0.5
                }}>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        size="small"
                        sx={{
                            color: darkMode ? '#f5f7fa' : '#333',
                            borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
                            minWidth: 'auto',
                            padding: '4px 12px',
                            fontSize: '0.75rem',
                            '&:hover': {
                                backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
                                borderColor: darkMode ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4)',
                            },
                        }}
                    >
                        Отмена
                    </Button>

                    <Button
                        onClick={() => setOpenConfirmDialog(true)}
                        variant="contained"
                        size="small"
                        disabled={error}
                        sx={{
                            backgroundColor: error
                                ? (darkMode ? '#666' : '#ccc')
                                : (mode
                                    ? (darkMode ? '#78A75A' : '#5D8246')
                                    : (darkMode ? '#EA3323' : '#C42B1D')
                                ),
                            color: darkMode ? '#1e1e1e' : '#fff',
                            minWidth: 'auto',
                            padding: '4px 12px',
                            fontSize: '0.75rem',
                            '&:hover': {
                                backgroundColor: error
                                    ? (darkMode ? '#666' : '#ccc')
                                    : (mode
                                        ? (darkMode ? '#78A75A' : '#5D8246')
                                        : (darkMode ? '#EA3323' : '#C42B1D')
                                    ),
                            },
                            '&:disabled': {
                                backgroundColor: darkMode ? '#666' : '#ccc',
                                color: darkMode ? '#999' : '#666',
                            },
                        }}
                    >
                        {mode ? 'Подтвердить выполнение' : 'Отменить выполнение'}
                    </Button>

                </DialogActions>

                {/* Элементы для изменения размеров в smallMode */}
                {smallMode && (
                    <>
                        {/* Правый нижний угол для изменения размеров */}
                        <div
                            className="resize-handle"
                            style={{
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                width: '16px',
                                height: '16px',
                                cursor: 'nw-resize',
                                background: darkMode
                                    ? 'linear-gradient(-45deg, transparent 30%, #666 30%, #666 40%, transparent 40%, transparent 60%, #666 60%, #666 70%, transparent 70%)'
                                    : 'linear-gradient(-45deg, transparent 30%, #ccc 30%, #ccc 40%, transparent 40%, transparent 60%, #ccc 60%, #ccc 70%, transparent 70%)',
                                zIndex: 1
                            }}
                            onMouseDown={handleResizeHandleMouseDown}
                        />
                        {/* Нижняя граница для изменения высоты */}
                        <div
                            className="resize-handle"
                            style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: '16px',
                                height: '4px',
                                cursor: 'ns-resize',
                                zIndex: 1
                            }}
                            onMouseDown={handleResizeHandleMouseDown}
                        />
                        {/* Правая граница для изменения ширины */}
                        <div
                            className="resize-handle"
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                bottom: '16px',
                                width: '4px',
                                cursor: 'ew-resize',
                                zIndex: 1
                            }}
                            onMouseDown={handleResizeHandleMouseDown}
                        />
                    </>
                )}
            </Dialog>

            {/* =================== ДИАЛОГ ПОДТВЕРЖДЕНИЯ =================== */}
            <Dialog
                open={openConfirmDialog}
                onClose={() => setOpenConfirmDialog(false)}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 2999,
                            backgroundColor: darkMode ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.6)'
                        }
                    },
                    paper: {
                        sx: {
                            zIndex: 3000,
                            backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                            color: darkMode ? '#f5f7fa' : '#333',
                            borderRadius: '12px',
                            boxShadow: darkMode
                                ? '0 8px 32px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.1)'
                                : '0 8px 32px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)'
                        }
                    }
                }}
                style={{ zIndex: 3000 }}
            >
                <DialogTitle sx={{
                    backgroundColor: darkMode ? '#2b2b2b' : '#fff',
                    color: darkMode ? '#f5f7fa' : '#333',
                    borderBottom: darkMode
                        ? '1px solid rgba(255, 255, 255, 0.12)'
                        : '1px solid rgba(0, 0, 0, 0.12)',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    padding: '8px 12px'
                }}>
                    Подтверждение
                </DialogTitle>
                <DialogContent sx={{
                    backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                    color: darkMode ? '#f5f7fa' : '#333',
                    padding: '12px 16px'
                }}>
                    <Typography sx={{
                        color: darkMode ? '#f5f7fa' : '#333',
                        fontSize: '0.9rem'
                    }}>
                        Вы уверены, что хотите отправить изменения?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{
                    backgroundColor: darkMode ? '#2b2b2b' : '#fff',
                    borderTop: darkMode
                        ? '1px solid rgba(255, 255, 255, 0.12)'
                        : '1px solid rgba(0, 0, 0, 0.12)',
                    padding: '8px 12px',
                    gap: 0.5
                }}>
                    <Button
                        onClick={() => setOpenConfirmDialog(false)}
                        variant="outlined"
                        size="small"
                        sx={{
                            color: darkMode ? '#f5f7fa' : '#333',
                            borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
                            minWidth: 'auto',
                            padding: '4px 12px',
                            fontSize: '0.75rem',
                            '&:hover': {
                                backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
                                borderColor: darkMode ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4)',
                            },
                        }}
                    >
                        Отмена
                    </Button>
                    <Button
                        onClick={handleSend}
                        variant="contained"
                        size="small"
                        sx={{
                            backgroundColor: darkMode ? '#64b5f6' : '#1976d2',
                            color: darkMode ? '#1e1e1e' : '#fff',
                            minWidth: 'auto',
                            padding: '4px 12px',
                            fontSize: '0.75rem',
                            '&:hover': {
                                backgroundColor: darkMode ? '#42a5f5' : '#1565c0',
                            },
                        }}
                    >
                        Подтвердить
                    </Button>
                </DialogActions>
            </Dialog>

            {/* =================== УВЕДОМЛЕНИЯ =================== */}
            <Snackbar
                open={showSuccessAlert}
                autoHideDuration={2000}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
                    Изменения успешно сохранены
                </Alert>
            </Snackbar>
            <Snackbar
                open={showErrorAlert}
                autoHideDuration={2000}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>
                    {errorAlertMessage}
                </Alert>
            </Snackbar>


            {
                isLoading && createPortal(
                    <Box sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        pointerEvents: 'none',
                        zIndex: 9999,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)'
                    }}>
                        <CircularProgress />
                    </Box>,
                    document.body
                )
            }
        </>
    );
};

// =================== ЭКСПОРТ КОМПОНЕНТА ===================
export default ModalExecution